module.exports = __webpack_public_path__ + "static/media/GettyImages-1066869278.2623b355.mp4";